import type { Route } from "../../../../../utils/models/Route";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for adding a new route (the "Add Route" button, and "Add route to
 * this day"). Assigning the new route's day can also silently reassign an
 * existing route onto day 1 (see the createNewRoute mutation), so — like
 * ApplyDayCountCommand/MergeAllRoutesCommand — this snapshots the whole
 * routes map wholesale rather than trying to invert the day-assignment
 * algebra.
 */
export class AddRouteCommand implements UndoCommand {
  readonly type = 'ADD_ROUTE';
  readonly routeKey: string;

  private routesBefore: { [key: string]: Route };
  private routesAfter: { [key: string]: Route };
  private activeRouteKeyBefore: string | null;
  private activeRouteKeyAfter: string | null;

  constructor(data: {
    newRouteKey: string;
    routesBefore: { [key: string]: Route };
    routesAfter: { [key: string]: Route };
    activeRouteKeyBefore: string | null;
    activeRouteKeyAfter: string | null;
  }) {
    this.routeKey = data.newRouteKey;
    this.routesBefore = JSON.parse(JSON.stringify(data.routesBefore));
    this.routesAfter = JSON.parse(JSON.stringify(data.routesAfter));
    this.activeRouteKeyBefore = data.activeRouteKeyBefore;
    this.activeRouteKeyAfter = data.activeRouteKeyAfter;
  }

  undo(ctx: CommandContext): void {
    ctx.state.routes = JSON.parse(JSON.stringify(this.routesBefore));
    ctx.state.activeRouteKey = this.activeRouteKeyBefore;
    ctx.state._statsVersion++;
  }

  redo(ctx: CommandContext): void {
    ctx.state.routes = JSON.parse(JSON.stringify(this.routesAfter));
    ctx.state.activeRouteKey = this.activeRouteKeyAfter;
    ctx.state._statsVersion++;
  }
}
